import React from 'react';
import classnames from 'classnames';
import './index.scss';
import { RootState } from '@/redux/store';
import { useSelector } from 'react-redux/es/hooks/useSelector';

const TrafficLight = () => {
  const styleTextRed = useSelector(
    (state: RootState) => state.trafficLight?.data?.[0]?.style_text_red
  );
  const styleTextGreen = useSelector(
    (state: RootState) => state.trafficLight?.data?.[0]?.style_text_green
  );
  const styleTextYellow = useSelector(
    (state: RootState) => state.trafficLight?.data?.[0]?.style_text_yellow
  );

  return (
    <div className="traffic-light-group">
      <i
        className={classnames('unknown-light', {
          'red-light': styleTextRed === 'light_red_major',
          'red-flashing-light': styleTextRed === 'light_red_twinkle',
        })}
      ></i>
      <i
        className={classnames('unknown-light', {
          'green-light': styleTextGreen === 'light_green_major',
          'green-flashing-light': styleTextGreen === 'light_green_twinkle',
        })}
      ></i>
      <i
        className={classnames('unknown-light', {
          'yellow-light': styleTextYellow === 'light_yellow_major',
          'yellow-flashing-light': styleTextYellow === 'light_yellow_twinkle',
        })}
      ></i>
    </div>
  );
};

export default React.memo(TrafficLight);
